import React from 'react';

export function Loading({ size = 'md', text = null }) {
  const dim = size === 'sm' ? 'w-5 h-5' : size === 'lg' ? 'w-8 h-8' : 'w-6 h-6';
  return (
    <div className="flex items-center gap-2">
      <svg className={`animate-spin ${dim} text-tertiary`} viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
      </svg>
      {text ? <span className="text-tertiary text-sm">{text}</span> : null}
    </div>
  );
}

export function ProductSkeleton() {
  return (
    <div className="border-2 border-tertiary bg-primary p-4 animate-pulse">
      <div className="bg-black/20 h-40 mb-3" />
      <div className="bg-black/20 h-4 w-3/4 mb-2" />
      <div className="bg-black/20 h-4 w-1/2" />
    </div>
  );
}


